import React from 'react'
import { Chip } from '@material-ui/core'

const SubScopeChip = ({ subScope, onToggle, onRemove }) => {
  return (
    <Chip
      label={subScope.label}
      size="small"
      color={subScope.selected ? 'primary' : 'default'}
      variant={subScope.selected ? 'default' : 'outlined'}
      onClick={() => onToggle(subScope.key)}
      onDelete={subScope.isCustom ? () => onRemove(subScope.key) : undefined}
      style={{ margin: 2 }}
    />
  )
}

export default SubScopeChip
